import { Grid } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { OPCheckBox } from '../../../OPcomponents/OPCheckBox'
import CVCard from './CVCard'
import { useCVSettings } from './CVSettingsContext'

export const LanguageSkillsCard: React.FC = () => {
  const { t } = useTranslation()
  const { state, handleSwitchChange } = useCVSettings()
  const { inc_languages, inc_languagelevel, inc_languagedescription } = state

  return (
    <CVCard
      title={t('CVTemplates.LanguageSkill')}
      description={t('CVTemplates.LanguageSkillsAndProficiency')}
      isEnabled={inc_languages}
      toggleName='inc_languages'
      onToggleChange={handleSwitchChange}
    >
      <Grid item>
        <OPCheckBox
          name='inc_languagelevel'
          label={t('CVTemplates.ShowProficiencyLevel')}
          value={inc_languagelevel}
          onChangeState={handleSwitchChange}
        />
      </Grid>
      <Grid item>
        <OPCheckBox
          name='inc_languagedescription'
          label={t('CVTemplates.ShowLanguageDescription')}
          value={inc_languagedescription}
          onChangeState={handleSwitchChange}
        />
      </Grid>
    </CVCard>
  )
}
